// TextInput — presentation primitive. Native <input>. Selector-free,
// dispatch-free. The surrounding Field primitive wires id /
// aria-describedby / aria-invalid via React.cloneElement; consumers
// using TextInput outside a Field can pass them directly.
//
// Props:
//   id:           string — input id (Field injects this)
//   name:         string — passed through
//   type:         string — 'text'|'email'|'url'|'tel'|... — default 'text'
//   value:        string — controlled value
//   onChange:     (event) => void
//   onBlur:       (event) => void
//   placeholder:  string
//   maxLength:    number
//   autoComplete: string
//   disabled:     bool
//   className, ...rest

function TextInput({
  id,
  name,
  type = 'text',
  value,
  onChange,
  onBlur,
  placeholder,
  maxLength,
  autoComplete,
  disabled = false,
  className = '',
  ...rest
}) {
  const classes = [
    'ui-text-input',
    disabled ? 'ui-text-input--disabled' : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <input
      id={id}
      name={name}
      type={type}
      value={value ?? ''}
      onChange={onChange}
      onBlur={onBlur}
      placeholder={placeholder}
      maxLength={maxLength}
      autoComplete={autoComplete}
      disabled={disabled}
      className={classes}
      {...rest}
    />
  );
}

export default TextInput;
